
import {Component, Vue} from "vue-property-decorator";
import SidebarPanier from "@/components/panier/SidebarPanier.vue";
import i18n from "../plugins/vue-i18n";
import {namespace} from "vuex-class";
import panierService from "@/services/panier.service";
import frontService from "@/services/front.service";
import Baskets from "@/components/utils/Baskets.vue";

const userModule = namespace("userModule");
const panierModule = namespace("panierModule")

@Component({
    components: {
        SidebarPanier,
        Baskets
    }
})
export default class Qualite extends Vue {
    items = [
        {tab: i18n.tc("enrichissement.tabs.files"), content: "FilesQualite"},
        {tab: i18n.tc("qualite.tabs.selection"), content: "DatatypeQualite"},
        {tab: i18n.tc("enrichissement.tabs.export"), content: "ExportQualite"}
    ];
    result = {
        nb: 0,
        credits: 0
    };

    panier = {
        products: [],
        isDeleting: false
    };

    @userModule.State
    public user!: any;
    @userModule.Action
    public getUser;

    @panierModule.Action
    public removeProduct!: () => void;

    isLoadingData = false;

    resetTrigger = false;


    headers = [
        {
            text: "Type",
            value: "type",
        },
        {
            text: "Segment",
            value: "segment",
        },
        {
            text: "Date",
            value: "date",
        },
        {
            text: "Résultats",
            value: "results",
        },
        {
            text: "Crédits",
            value: "credits",
        },
        {
            text: "Format",
            value: "format",
        },
        {text: "Actions", value: "actions", sortable: false}
    ];

    setPanier(items) {
        this.isLoadingData = false;
        console.log(items);
        this.panier.products = items;
    }

    loadBasket() {
        panierService.getCurrentBasketFromUser(this.user.id).then(res => {
            this.panier.products = [];
            res.data.message.Items.forEach(element => {
                const line = {
                    id: element.basketId,
                    type: element.basketType == 1 ? 'comptage' : (element.basketType == 2 ? 'enrichissement' : element.basketType == 3 ? 'qualite' : null),
                    segment: element.basketSegment === true ? 'Établissements' : 'Entreprise',
                    date: element.lastUpdate,
                    results: element.basketResult,
                    credits: element.credit,
                    format: element.basketFormat,
                    state: element.basketStatus,
                    fileId: element.fileId,
                    filters: element.filters
                    // email ?
                };
                this.panier.products.push(line);
            });
            this.isLoadingData = false;
        });
    }

    created() {
        if (!this.user.id) {
            this.getUser();
        }
    }

    img(value) {
        return require('@/assets/' + value);
    }

    clearBasket(args) {
        this.panier.products = [];
        this.resetTrigger = !this.resetTrigger;
    }
}
